import {createSelector} from '@ngrx/store';
import {AppState} from '../states/app.state';
import {identity} from 'rxjs';

export class MoveBelegDialogSelectors {
  private static select = {
    isOpen: (state: AppState) => state.moveBelegDialog.isOpen,
    sourceInhaberId: (state: AppState) => state.moveBelegDialog.sourceInhaberId,
    belegIds: (state: AppState) => state.moveBelegDialog.belegIds,
  };

  public static isMoveBelegDialogOpen = createSelector(this.select.isOpen, identity);

  public static sourceInhaberId = createSelector(this.select.sourceInhaberId, identity);

  public static belegIds = createSelector(this.select.belegIds, identity);
}
